export default __webpack_public_path__ + "static/media/titleTokensMobile.51e01b69.svg";